import React from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Container from '@components/Container';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    color: 'rgba(0, 0, 0, 1)',
    backgroundColor: 'rgba(255, 255, 255)',
  },
  title: {
    fontSize: rem(16),
    marginTop: rem(8),
  },
  subTitle: {
    fontSize: rem(12),
    color: 'rgba(17, 19, 25, 1)',
    marginTop: rem(20),
    margin: [rem(8), 0],
  },
  item: {
    margin: [rem(8), 0],
    fontSize: rem(12),
    '& > span:first-child': {
      display: 'inline-block',
      width: 60,
      color: 'rgba(140, 140, 140, 1)',
    },
    '& > span:last-child': {
      marginLeft: rem(10),
      color: 'rgba(0, 0, 0, 1)',
    },
  },
  shopCar: {
    position: 'fixed',
    right: 30,
    bottom: rem(120),
    zIndex: 99,
    backgroundColor: 'transparent',
  }
}), {
  name: 'ProductInfo'
})

const ProductInfo = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { t, data } = props;

  const skuData = R.pathOr({}, ['jsonData', 'sku'])(data);
  const products = R.pathOr([], ['base', 'productparames'])(skuData);

  const displayInfo = R.pathOr({}, ['jsonData', 'customizedDisplayInfo'])(data);
  const cartLink = R.pathOr('', ['custom', 'shoppingcartlink'])(displayInfo);

  return (
    <Container className={classNames(classes.root)} id='details'>

      <Container 
        flex 
        direction='column'
      >
        <h2 className={classes.title} value='details'>{t('pro_dts')}</h2>
        <p className={classes.subTitle}>{t('pro_sps')}</p>
        {
          products && products.map(item => (
            <p key={String(item.key)} className={classes.item}>
              <span>{item.key || t('noData')}</span>
              <span>{item.value || t('noData')}</span>
            </p>
          )) 
        }
      </Container>
      {
        cartLink && (
          <a href={cartLink} rel='noreferrer' className={classes.shopCar}>
            <img
              src='./static/images/products/shopcar.png'
              alt='Shop car'
              height='55'
              width='55'
            />
          </a>
        )
      }
      
    </Container>
  )
};

ProductInfo.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}

export default ProductInfo;
